"use client";

import { DestinationHeader } from "@/types/dto/destinations-page/destination-page-types";
import React from "react";
import {useTranslations} from "next-intl";
import PageHero from "@/components/common/page-hero/page-hero";

export interface DestinationsHeroProps {
  destinationHeader: DestinationHeader;
  destinationName?: string;
  numTours?: number;
  startMuted?: boolean;
}

export const DestinationsHero: React.FC<DestinationsHeroProps> = ({
  destinationHeader,
  destinationName,
  numTours,
  startMuted = false
}) => {
  const { basicInfo, video, headerImage } = destinationHeader;
  const t = useTranslations("DESTINATIONS");

  return (
    <PageHero
      testId="destination"
      heroHeader={
        t("Destinations Page Header", {
          destinationName,
          numTours
        })
      }
      heroBasicInfo={basicInfo}
      video={{
        videoId: video ?? "",
        videoTitle: `${destinationName} destination video`
      }}
      startMuted={startMuted}
      headerImage={headerImage}
    />
  );
};
